import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchWelcomePageNewsItemsAction } from './actions/fetchWelcomePageNewsItems';

import {WelcomePageNewsBlock} from './welcomePageNewsBlock';

const mapStateToProps = (state: IState) => ({
    newsItems: state.welcomePageContent.newsItems
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchWelcomePageNewsItems: () => dispatch(fetchWelcomePageNewsItemsAction())
});

export const WelcomePageNewsBlockContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WelcomePageNewsBlock);


// WEBPACK FOOTER //
// ./src/components/welcomePageNewsBlock/welcomePageNewsBlockContainer.tsx